module.exports = __webpack_public_path__ + "assets/media/3.da19f359.wav";